/**
 * Helper Functions for filtering a content item to a specific item from antoher content item
 * changes the baseContent Item in Place!
 */

import { Content } from '@23degrees/shared-code/models';
import { AdvancedTooltip } from '@23degrees/shared-code/models';
import { scaleLinear } from 'd3-scale';

export const calculateHeightWidth = (
  baseContent: Content,
  advancedTooltip: AdvancedTooltip,
  isMobile: boolean,
  currentWidth: number,
  currentHeight: number,
  appearanceSettings
) => {
  // console.log('[CalculateHeightWidth]', appearanceSettings);
  console.log('[CalculateHeightWidth]', currentWidth, currentHeight);
  //widthPercent -> from embedWidth
  let maxWidth = undefined;
  let maxHeight = undefined;
  //get the max size dependant on tooltip type
  if (advancedTooltip.type === 'classic') {
    if (isMobile) {
      const maxWidthPercent = advancedTooltip.style.classic.maxWidth.mobile.value;
      const maxHeightPercent = advancedTooltip.style.classic.maxHeight.mobile.value;
      maxWidth = Math.round(currentWidth * (maxWidthPercent / 100));
      maxHeight = Math.round(currentHeight * (maxHeightPercent / 100));
    } else {
      const maxWidthPercent = advancedTooltip.style.classic.maxWidth.desktop.value;
      const maxHeightPercent = advancedTooltip.style.classic.maxHeight.desktop.value;
      maxWidth = Math.round(currentWidth * (maxWidthPercent / 100));
      maxHeight = Math.round(currentHeight * (maxHeightPercent / 100));
    }
  }
  if (advancedTooltip.type === 'fullscreen') {
    maxWidth = currentWidth;
    maxHeight = currentHeight;
  }
  if (advancedTooltip.type === 'sidebar') {
    maxWidth = currentWidth;
    maxHeight = currentHeight;
  }

  const width = maxWidth * (appearanceSettings.embedWidth / 100);

  // calculate height
  let aspectRatio = 1.33;
  if (baseContent?.typeSpecific?.style) {
    const { breakPoints } = baseContent.typeSpecific.style;

    const domain = breakPoints.values.map((obj) => obj.domain);
    const range = breakPoints.values.map((obj) => obj.aspectRatio);

    const aspectScale = scaleLinear().domain(domain).range(range).clamp(true);

    aspectRatio = aspectScale(width);
  }

  let height = Math.floor(width / aspectRatio);
  const baseMaxHeight = maxHeight;
  if (appearanceSettings.maxHeightEnabled) {
    maxHeight = Math.floor(maxHeight * (appearanceSettings.maxHeight / 100));
  }
  if (height > maxHeight) {
    height = maxHeight;
  }
  return { width: width, height: height, baseMaxHeight: baseMaxHeight, baseMaxWidth: maxWidth };
};

/**
 * if possible filters a visual to the given value on the field.
 * Does in place replacement
 * @param  content        to filtered content
 * @param  content        to filtered content
 * @return content filtered content
 */
export const filterVisual = (content, filterField, filterFieldValue) => {
  let found = false;
  if (content.typeSpecific.inVisualFilter.length > 0) {
    const uniqueFilter = content.typeSpecific.inVisualFilter.find((el) => el.type === 'valueSelector' && el.fieldName === filterField.fieldName);
    if (uniqueFilter) {
      uniqueFilter.selectedValue = filterFieldValue;
      uniqueFilter.options.saveState = 'userSelected';
      // console.log('[VisualJoins] uniqueFilter', uniqueFilter);
      // console.log('[VisualJoins] filterFieldValue', filterFieldValue);
      found = true;
    }
  }

  if (!found) {
    // try in editor filters
    content.typeSpecific.fields[filterField.fieldName].selectedValues = [filterFieldValue];
  }

  return content;
};

export const joinVisual = (baseContent, joinConfig, joinDataRow) => {
  //content and baseContent are available
  //what can be
  //we are joining with iso fields
  //the label field may also be in a filter or in an invisual Filter
  //first check where it is in
  const targetField = baseContent.typeSpecific.fields[joinConfig.targetFieldName];
  const filterFieldValue = joinDataRow[joinConfig.sourceFieldName];
  if (targetField) {
    filterVisual(baseContent, targetField, filterFieldValue);
  }

  return baseContent;
};
